import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";

export const AddEditButton = styled(Button)({
  fontSize: "1em",
  textTransform: "none",
  whiteSpace: "nowrap",
  borderRadius: 0,
  padding: "0px",
});
